import type { AuthError } from '@supabase/supabase-js';

export const EMAIL_NOT_CONFIRMED_MESSAGE =
  'Email not confirmed. Please check your inbox and confirm your email before signing in.';

export function mapLoginError(error: AuthError | Error): string {
  const authErr = error as AuthError;
  const code = authErr.code;
  const message = error.message || '';

  if (
    code === 'email_not_confirmed' ||
    /email not confirmed/i.test(message) ||
    /email not verified/i.test(message)
  ) {
    return EMAIL_NOT_CONFIRMED_MESSAGE;
  }

  if (/invalid login credentials/i.test(message)) {
    return 'Invalid email or password.';
  }

  return message || 'Could not sign in. Please try again.';
}
